<template>

	<div class="backgroundClass">
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">积分商城>积分获取记录 </div>
		<div class="first_line" style="width: 60%;">
			<el-date-picker class="jul" size="small" v-model="addDataList.time" type="datetimerange"
				value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
			</el-date-picker>
			<!-- 获取ID、获取途径、联系方式/用户昵称 -->
			<el-select class="jul" v-model="query.type" style="width: 200px;" size="small" placeholder="获取ID">
				<el-option v-for="item in keys" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-input type="text" style="width: 250px;margin-right: 20px;" size="small" v-model="query.text"
				@keydown.enter.native="filterOrder()">
			</el-input>
			<!-- <el-select class="jul" size="small"placeholder="订单状态">
					<el-option v-for="item in statelist" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select> -->
			<el-button class="jul" type="primary" size="small" @click="integralOrderList()">筛选</el-button>
			<el-button @click="addCoupons = true">详情</el-button>
			<!-- @click="integralOrderList()" -->
			<!-- @click="addCoupons = true" -->
		</div>
		<el-tabs type="border-card" @tab-click="pagechange()">
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="couponList"
				tooltip-effect="dark" style="width: 100%">
				<el-table-column label="获取ID" width="150px"></el-table-column>
				<!-- <el-table-column label="获取编号" width="150px"></el-table-column> -->
				<el-table-column label="获取途径" width="150px"></el-table-column>
				<el-table-column label="用户ID" width="150px"></el-table-column>
				<el-table-column label="用户属性" width="100px"></el-table-column>
				<el-table-column label="联系电话" width="150px"></el-table-column>
				<el-table-column label="获取积分数" width="150px"></el-table-column>
				<!-- <el-table-column label="邀请人" width="150px"></el-table-column> -->
				<el-table-column label="被分享人ID" width="150px"></el-table-column>
				<el-table-column label="被成功分销用户ID" width="150px"></el-table-column>
				<el-table-column label="创建时间" width="150px"></el-table-column>
				<el-table-column width="175" label="操作" align="right">
					<template slot-scope="scope">
						<div>
							<el-button type="text">编辑</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagescg">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
					layout="total, sizes, prev, pager, next, jumper" :total="query.total">
				</el-pagination>
			</div>
		</el-tabs>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				pushid: "",
				sendDialog: false,
				query: {
					type: 0,
					text: "",
					overStatus: "1",
					name: "",
					status: -1,
					page: 1,
					size: 30,
					total: 0,
				},
				keys: [{
						label: "获取ID",
						value: 0,
					},{
						label: "获取途径",
						value: 1,
					},{
						label: "用户昵称/手机号",
						value: 3,
					},{
						label: "用户ID",
						value: 4,
					}
				],
				time: undefined,
				statelist: [],
				couponList: [],
				storeval: [],
				addDataList: [],
				dialog_user: false,
				tableData_1: [],
				checkList: [],
				addCoupons: false,
			};
		},
		mounted() {
			this.integralOrderList();
		},
		methods: {
			filterOrder() {
				this.getOrders();
				this.getSummary();
			},
			getOrders() {
				this.loading = true;
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)
				this.$http.get("dOrder/list" + this.requestData()).then(res => {
					if (res.data.code == 200) {
						this.orders = res.body.data.rows;
						this.query.total = res.body.data.total;
					} else {
						this.$message.error(res.data.msg);
					}
					this.loading = false
					clearTimeout(t)
					console.log("销毁定时器")
				})
			},
			requestData() {
				let query = "?page=" + this.query.page + "&size=" + this.query.size;
				if (this.query.text) query += "&type=" + this.query.type + "&text=" + this.query.text;
				if (this.query.time) query += "&startTime=" + this.query.time[0] + "&endTime=" + this.query.time[1];
				if (this.query.orderStatus !== 100) query += "&orderStatus=" + this.query.orderStatus.toString();
				if (this.query.orderType) query += "&orderType=" + this.query.orderType;
				if (this.query.channel) query += "&channel=" + this.query.channel;
				if (this.query.payType) query += "&payType=" + this.query.payType;
				if (this.query.storeId) query += "&storeId=" + this.query.storeId;
				if (this.query.timeType) query += "&timeType=" + this.query.timeType;
				return query;
			},
			reload() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					type: 1,
					text: "",
					addTime: null,
					orderStatus: [],
					orderType: "",
					channel: "",
					payType: "",
					timeType: '0'
				};
				this.getOrders();
				this.getSummary();
			},
			// 添加 页面渲染函数
			integralOrderList() {},
			//详情
			deit(id) {
				this.$router.push({
					path: 'newvolumeset',
					query: {
						id: id
					}
				})
			},
			//保存修改
			update() {
				this.$delete(row, 'edit')
				var a = {
					// 订单ID"
					// 订单编号"
					// 订单类型"
					// 商品名称"
					// 用户昵称"
					// 用户属性"
					// 联系电话"
					// 服务价格"
					// 使用优惠券
					// "实际支付"
					// "订单创建时间
					// "支付时间"
					// "订单状态"
					// "积分状态"
					// 获得积分数
					// 使用积分数"
					id: row.id,
					code: row.code,
					couponId: row.couponId,
					status: row.status,
					userId: row.userId,
					nickName: row.nickName,
					outsideCode: row.outsideCode,
					expiredTime: row.expiredTime
				}
				this.$http.post("handle/saveCouponCode", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.getCouponCode()
					} else {
						this.$message.error("保存失败")
					}
				})
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.getCouponList();
			},
			handleCurrentChange(val) {
				this.query.page = val
				this.getCouponList();
			},
			pagechange() {
				this.query.size = 10
				this.query.page = 1
				this.getCouponList()
			},
			jump() {
				this.$router.push({
					path: '/newvolumeset',
				})
			},
		},
	};
</script>
<style lang="less" scoped>
	.grid-content {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
	}

	.main-number {
		font-family: SourceHanSansCN-Bold;
		font-size: 22px;
	}

	.main-content {
		padding: 30px 20px 20px 20px;
	}

	.green01 {
		height: 14px;
		width: 5px;
		background-color: #4AB52E;
		margin: 5px 0 0 0
	}

	.topTitle {
		display: flex;
	}

	.green02 {
		width: 5px;
		height: 5px;
		background: #4AB52E;
		margin: 15px 5px 0 5px
	}

	.topTitleSmall {
		margin: 5px 0 0 0;
		font-size: 18px;
		font-family: SourceHanSansCN-Bold;
	}

	.tanchutitle {
		margin-top: -30px;
		width: 100%;
		height: 42px;
		line-height: 42px;
		background-color: #F2F2F2;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #888888;
		box-sizing: border-box;
		padding-left: 10px;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	// 弹出框内容
	.dia_title {
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #525252;
	}

	.dialog-footer {
		margin-top: -10px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.el-select {
			width: 120px;
		}

		.el-input {
			width: 180px;
		}

		.jul {
			margin-left: 10px;
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 
	.boton {
		display: flex;

		div {
			margin-right: 15px;
			flex-wrap: wrap;

			.boton1_title {
				cursor: pointer;
				height: 32px;
				padding-left: 8px;
				padding-right: 8px;
				border: 1px dashed #D9DCE3;
				border-radius: 4px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				line-height: 32px;
				text-align: center;
			}

			.botonlist {
				margin-top: 15px;
				text-align: center;
				line-height: 32px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				width: 99px;
				height: 32px;
				border: 1px solid #D9DCE3;
				border-radius: 4px;
				position: relative;

				div {
					cursor: pointer;
					line-height: 15px;
					position: absolute;
					width: 16px;
					height: 16px;
					background-color: black;
					color: white;
					border-radius: 50%;
					font-size: 14px;
					right: -8px;
					top: -8px;
				}
			}
		}
	}

	.bon_data {
		display: flex;

		div {
			padding-left: 5px;
			padding-right: 5px;
		}
	}

	.lastbottom {
		width: 138px;
		margin-left: 29%;
		margin-top: 25px;
	}

	.duo {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #959595;
		opacity: 0.51;
		margin-top: -4px;
	}

	.lastdig {
		/deep/.el-dialog__close {
			display: none;
		}

		.mybotton {
			margin-left: 39%;
			margin-top: 15px;
		}
	}
</style>